<template>
    <div>
      <div v-if="this.rmData['RoleId']=='1'">
        <innerheader />
      </div>
      <div v-else>
      <innerheaderDIY/>
      </div>
        <docsubmitted />
    </div>
</template>

<script>
// @ is an alias to /src
import innerheaderDIY from "@/components/innerheader/innerHeaderDIY.vue";
import innerheader from "@/components/innerheader/innerheader.vue";
import docsubmitted from "@/components/uploaddocument/upload-doc-diy.vue";

export default {
  name:' uploaddocdiy',
  components: {
     innerheader,
     innerheaderDIY,
     docsubmitted
  },
  data()
  {
    return{
      rmData:"",
    }
  },
  mounted()
  {
     if(sessionStorage.getItem("rm_data"))
     {
      this.rmData = JSON.parse(sessionStorage.getItem("rm_data"));
     }
  }
}
</script>

<style scoped lang="scss">
@import '~@/assets/scss/components/uploaddoc.scss';
</style>